module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"mw-architettura","short_name":"MW","start_url":"/","background_color":"#f7f0eb","theme_color":"#fafbfc","display":"minimal-ui","icon":"src/assets/icons/mw_logo.png","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"909be0c88d11caec08907e0e5ce38439"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
